/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Content from 'app/components/common/Content.jsx';
import { FormattedDate } from 'react-intl';
import { FormattedNumber } from 'react-intl';
import Loading from 'app/components/common/Loading.jsx';
import EmptyState from 'app/components/common/EmptyState.jsx';
import * as _ from 'underscore';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';

class PaymentHistory extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            invoices: [],
            initialLoad: true,
            loadingInvoice: 0
        };

        this.openInvoice = this.openInvoice.bind(this);

    }

    componentDidMount() {

        if (this.props.user.detail.isAgent === false) {
            this.props.getInvoices();
        }

    }

    componentDidUpdate(prevProps, prevState) {
        let constants = this.props.app.config.constants;

        if (prevProps.app.loading.SUB_FETCH_INVOICES === true && this.props.app.loading.SUB_FETCH_INVOICES === false) {
            if (this.props.plans.invoices.length === 0 && this.props.isFreeUser()) {
                this.props.router.navigate('/account/subscription/new');
            }
        }

        if (_.isEmpty(prevProps.plans.invoice) && !_.isEmpty(this.props.plans.invoice)) {
            let pdf = document.createElement('a');
            pdf.target = "_blank";
            pdf.download = "invoice.pdf";
            pdf.href = "data:application/pdf;base64," + invoice;
            pdf.click();
        }

    }

    openInvoice(e) {

        let id = e.currentTarget.dataset.invoice;

        window.open('/invoice.php?id=' + id);

    }

    render() {
        let header = null,
            main = null;

        header = (
            <div className="content-header white">
                <div className="account-header">Your Payment History</div>
            </div>
        );

        if (this.props.user.detail.isAgent) {
            main = <EmptyState message={"Sorry, only the account owner can access this page."}/>;
        } else if (!this.props.plans.invoices.length && this.props.app.loading.SUB_FETCH_INVOICES) {
            main = (
                <Loading/>
            );
        } else {
            main = (
                <div className="invoice-block">
                    <ul className="invoice-list">
                        <li className="invoice-list-header">
                            <div className="invoice-date heading">
                                Date
                            </div>
                            <div className="invoice-number heading">
                                Invoice
                            </div>
                            <div className="invoice-amount heading">
                                Amount
                            </div>
                            <div className="invoice-status heading">
                                Status
                            </div>
                        </li>
                        {this.props.plans.invoices.map((invoice, i) => {
                            return (
                                <li key={i} className="invoice-list-item">
                                    <div className="invoice-date heading">
                                        <FormattedDate value={invoice.date} month="short" day="numeric" year="numeric"/>
                                    </div>
                                    <div className="invoice-number heading">
                                        <div className="pseudo-link" onClick={this.openInvoice} data-invoice={invoice.number} role='link' aria-label={`open invoice #${invoice.number}`}>
                                            #{invoice.number}
                                        </div>
                                    </div>
                                    <div className="invoice-amount heading">
                                        <FormattedNumber value={invoice.amount} style="currency" currency="USD"/>
                                    </div>
                                    <div className="invoice-status heading">
                                        {invoice.status}
                                    </div>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            );
        }

        return (
            <Content header={header} main={main} />
        );
    }

};

PaymentHistory.displayName = "PaymentHistory";

export default ComponentWithContext(PaymentHistory);
